<template>
  <v-container grid-list-md text-xs-center>
    <v-layout align-center justify-center row wrap>
      <v-flex xs12 md8>
        <v-form v-model="valid" ref="merchandiseForm">
          <editable-select
              v-model="productTypeModel"
              id="ss-type-product"
              name="ss-type-product"
              label="Product name"
              itemText="name"
              itemName="Product"
              :itemList="productTypeList"
              height-dropdown="320"
          >
            <template v-slot:append-initial>
              <v-tooltip top dark max-width="250">
                <template slot="activator">
                  <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
                </template>
                <span>You need to select the product name or the category to which this product belongs from the list</span>
              </v-tooltip>
            </template>
          </editable-select>
          <v-text-field
              v-if="visibleBrandRule"
              name="brand_name"
              v-model="brandNameModel"
              :rules="brandNameRules"
              label="Brand name"
              required
          ></v-text-field>
          <v-number-field
              v-model="quantityModel"
              ref="ssQty"
              label="Quantity"
              id="ss-ui-qty"
          />
          <v-number-field
              v-model="priceModel"
              ref="ssPrise"
              label="Price($)"
              id="ss-ui-prise"
              float-mod
              input-mod="decimal"
              :reg-exp-rule="/^(0|[1-9]\d*)(\.[0-9]{1,2})?$/"
          />
          <v-layout align-center justify-start row wrap py-2>
            <v-flex>
              <div class="flex title">Total value: {{totalPrice}}$</div>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-center row wrap py-2>
            <v-flex xs6 md4>
              <v-btn
                  black
                  block
                  color="primary"
                  @click="addMerchandise"
                  :disabled="!isValidData"
              >
                {{ nameAction }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import SSProducts from '@/services/SelfServes/SSProducts'
import EditableSelect from '@/components/EditableSelect'
import VNumberField from '@/components/UI/VNumberField'

export default {
  name: 'SSMerchandiseForm',
  props:['product_id'],
  components: {
    EditableSelect,
    VNumberField,
  },
  data () {
    return {
      productTypeModel: null,
      quantityModel: null,
      brandNameModel: null,
      priceModel: null,
      product: null,
      valid: false,
      isValidData: false,
      productTypeList: [],
    }
  },
  created() {
    this.setDefaultValue();
  },
  computed: {
    brandNameRules() {
      if (this.$store.getters.ssGetCountryIso2 === this.$countryIso2.kr) {
        return [
          v => !!v || 'Brand name is required',
        ]
      }
    },
    totalPrice() {
      if (!!Number(this.quantityModel) && !!Number(this.priceModel)) {
        return (this.priceModel * this.quantityModel).toFixed(2);
      } else {
        return 0
      }
    },
    nameAction() {
      return this.product_id === 'add' ? 'ADD' : 'Save';
    },
    visibleBrandRule() {
      return this.$store.getters.ssGetCountryIso2 ? this.$store.getters.ssGetCountryIso2 !== this.$countryIso2.mn : true;
    },
    isValid() {
      return this.isValidData;
    }
  },
  watch: {
    priceModel() {
      this.isValidData = this.isValidForm();
    },
    quantityModel() {
      this.isValidData = this.isValidForm();
    },
    brandNameModel() {
      this.isValidData = this.isValidForm();
    },
    productTypeModel() {
      this.isValidData = this.isValidForm();
    },
  },
  methods: {
    isValidForm() {
      return !!this.getProductType() && this.$refs.ssQty.validate() && this.$refs.ssPrise.validate();
    },
    getProductType() {
      if (this.productTypeList.length > 0 && this.productTypeModel && this.productTypeModel.id) {
        return this.productTypeList.find((item) => this.productTypeModel.id === item.id);
      }
      return null;
    },
    addMerchandise() {
      if (this.isValidForm()) {
        const productType = this.getProductType();
        const productTypeId = productType ? productType.id : null;
        const hashCode = productType ? productType.hash_code : null;
        const product = {
          price: this.priceModel,
          quantity: this.quantityModel,
          product_type_id: productTypeId,
          description: this.productTypeModel.name,
          hash_code: hashCode,
        };
        if (this.brandNameModel) {
          product.brand = this.brandNameModel;
        }
        if (typeof this.product_id !== 'undefined' && this.product_id !== 'add') {
          this.$store.dispatch('ssSetProductById', {id: this.product_id, product: product})
        } else {
          this.$store.dispatch('ssSetProduct', product)
        }
        this.$router.push({name: 'SSMerchandises'});
      }
    },
    setDefaultValue() {
      this.getProductTypeList();
      this.setProduct();
    },
    setProduct() {
      if (typeof this.product_id !== 'undefined' && this.product_id !== 'add') {
        if (this.$store.getters.ssIsSetProducts) {
          this.product = this.$store.getters.ssGetProducts[this.product_id];
        }
      }
      if (this.product) {
        this.productTypeModel = {
          id: this.product.product_type_id || null,
          name: this.product.description || null,
          hash_code: this.product.hash_code || null,
        };
        this.quantityModel = this.product.quantity ? this.product.quantity : null;
        this.brandNameModel = this.product.brand ? this.product.brand : null;
        this.priceModel = this.product.price ? this.product.price : null;
      }
    },
    getProductTypeList() {
      if (!this.$store.getters.ssIsSetProductTypes) {
        SSProducts.getProductTypes()
            .then(resp => {
              if (resp.status === this.$response.Ok) {
                this.productTypeList = resp.data.data
                this.$store.dispatch('ssSetProductTypes', resp.data.data)
              }
            })
            .catch(error => {
              this.$store.commit('setError', error.response.data.message)
            })
      }
      else {
        this.productTypeList = this.$store.getters.ssGetProductTypes
      }
    },
  }
}
</script>